// Meta Pixel tracking utilities
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = (pixelId: string) => {
  // Check if already initialized
  if (window.fbq) return

  // Initialize fbq function
  const fbq = function () {
    // @ts-ignore
    fbq.callMethod
      ? // @ts-ignore
        fbq.callMethod.apply(fbq, arguments)
      : // @ts-ignore
        fbq.queue.push(arguments)
  }

  if (!window.fbq) window.fbq = fbq
  if (!window._fbq) window._fbq = fbq
  // @ts-ignore
  fbq.push = fbq
  // @ts-ignore
  fbq.loaded = true
  // @ts-ignore
  fbq.version = '2.0'
  // @ts-ignore
  fbq.queue = []

  // Load the pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  // Safely insert script - use head if no scripts exist yet
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }

  // Initialize pixel
  window.fbq('init', pixelId)
}

export const trackPageView = () => {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export const trackAddToCart = (params?: {
  content_name?: string
  content_ids?: string[]
  content_type?: string
  value?: number
  currency?: string
}) => {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', params)
  }
}
